__turbopack_context__.v({
  "guide": "Scanner-module__mrQPSW__guide",
  "overlay": "Scanner-module__mrQPSW__overlay",
  "overlay_text": "Scanner-module__mrQPSW__overlay_text",
  "scan_area": "Scanner-module__mrQPSW__scan_area",
  "video": "Scanner-module__mrQPSW__video",
});
